<template>
  <aside class="aside-menu">
    <div class="tab-content">
      <div role="tabpanel" aria-hidden="false" aria-expanded="true" class="tab-pane show fade active">

        <b-button type="button" variant="info" @click="lockAndConfirm()" class="btn btn-danger btn-lg btn-block">Lock Price & Confirm</b-button>

        <div class="m-0 py-2 text-muted text-center bg-light text-uppercase callout">
          <small><b>Total</b></small>
        </div>

        <hr class="transparent mx-3 my-0">

        <div class="m-0 py-3 callout callout-success" style="border-bottom-width: 1px;">
          <div>Buy Total: <strong>{{total_buy | currency}}</strong></div>
        </div>

        <div class="m-0 py-3 callout callout-primary">
          <div>Sell Total: <strong>{{total_sell | currency}}</strong></div>
        </div>

        <hr class="transparent mx-3 my-0">

        <div class="m-0 py-2 text-muted text-center bg-light text-uppercase callout">
          <small><b>You Are Buying</b></small>
        </div>

        <hr class="transparent mx-3 my-0">

        <div v-for="(item, index) in items_buy" class="m-0 py-1 callout callout-success" style="border-bottom-width: 1px;">
          <div style="padding-bottom: 7px;"><small><strong>{{item.sales_desc}}</strong></small></div>
          <div style="padding-bottom: 7px;"><small><strong style="color: red;" v-if="item.limit_quantity < item.quantity && !item.is_unlimited">Exceeds  </strong>Max Quantity : <strong v-if="item.is_unlimited">Unlimited</strong><strong v-if="! item.is_unlimited">{{item.limit_quantity}}</strong></small></div>
          <!-- <div style="padding-bottom: 7px;" v-if="item.use_percent === 1"><small>Display Premium: <strong>{{item.premium_ask_percentage.length === 1 ? item.premium_ask_percentage + "0" : item.premium_ask_percentage}}% </strong></small></div> -->
          <!-- <div style="padding-bottom: 7px;"><small>Display Premium: <strong>{{item.premium_ask}}<span v-if="item.melt_plus === false"> per ounce</span><span v-if="item.melt_plus === true"> per piece</span></strong></small></div> -->
          <div role="group" class="form-row b-form-group form-group" style="margin-bottom: 3px;">
            <label class="col-form-label col-sm-5 text-right">
              <span><small>Quantity :</small></span>
            </label>
            <div  v-if="!item.is_unlimited" class="col-sm-5">
              <input v-on:keyup="priceItems()" min=1 :max='item.limit_quantity' oninput="validity.valid||(value='1')" v-model="item.quantity" type="number" class="form-control form-control-sm col-sm-8 text-center">
            </div>
            <div  v-if="item.is_unlimited" class="col-sm-5">
              <input v-on:keyup="priceItems()" type="number" name="quantity" min="1" oninput="validity.valid||(value='1')" v-model="item.quantity" class="form-control form-control-sm col-sm-8 text-center">
            </div>
            <div class="col-sm-2">
              <button type="button" class="btn btn-danger btn-sm" v-on:click="removeBuyItem(index)"><i class="fa fa-remove"></i></button>
            </div>
          </div>
          <div class="text-center" style="padding-bottom: 3px">
            <small>{{item.quantity}} x {{item.price_ask | currency}} = <strong>{{item.quantity * item.price_ask | currency}}</strong></small>
          </div>
        </div>

        <hr class="transparent mx-3 my-0">

        <div class="m-0 py-2 text-muted text-center bg-light text-uppercase callout">
          <small><b>You Are Selling</b></small>
        </div>

        <hr class="transparent mx-3 my-0">

        <div v-for="(item, index) in items_sell" class="m-0 py-1 callout callout-primary" style="border-bottom-width: 1px;">
          <div style="padding-bottom: 7px;"><small><strong>{{item.sales_desc}}</strong></small></div>
          <div style="padding-bottom: 7px;"><small><strong style="color: red;" v-if="item.limit_quantity < item.quantity && !item.is_unlimited">Exceeds  </strong>Max Quantity : <strong v-if="item.is_unlimited">Unlimited</strong><strong v-if="! item.is_unlimited">{{item.limit_quantity}}</strong></small></div>
          <!-- <div style="padding-bottom: 7px;" v-if="item.use_percent === 1"><small>Display Premium: <strong>{{item.premium_ask_percentage.length === 1 ? item.premium_ask_percentage + "0" : item.premium_ask_percentage}}% </strong></small></div> -->
          <!-- <div style="padding-bottom: 7px;"><small>Display Premium: <strong>{{item.premium_bid}}<span v-if="item.melt_plus === false"> per ounce</span><span v-if="item.melt_plus === true"> per piece</span></strong></small></div> -->
          <div role="group" class="form-row b-form-group form-group" style="margin-bottom: 3px;">
            <label class="col-form-label col-sm-5 text-right">
              <span><small>Quantity:</small></span>
            </label>
            <div  v-if="!item.is_unlimited" class="col-sm-5">
              <input v-on:keyup="priceItems()" :max='item.limit_quantity'  v-model="item.quantity" type="number" class="form-control form-control-sm col-sm-8 text-center">
            </div>
            <div  v-if="item.is_unlimited" class="col-sm-5">
              <input v-on:keyup="priceItems()" type="number" name="quantity"  v-model="item.quantity" class="form-control form-control-sm col-sm-8 text-center">
            </div>
            <div class="col-sm-2">
              <button type="button" class="btn btn-danger btn-sm" v-on:click="removeSellItem(index)"><i class="fa fa-remove"></i></button>
            </div>
          </div>
          <div class="text-center" style="padding-bottom: 3px">
            <small>{{item.quantity}} x {{item.price_bid | currency}} = <strong>{{item.quantity * item.price_bid | currency}}</strong></small>
          </div>
        </div>

        <hr class="transparent mx-3 my-0">

        <div>
          <button type="button" class="btn btn-danger" v-on:click="removeAllClose()"><i class="fa fa-remove"></i></button>
        </div>

      </div>
    </div>
    
    <b-modal title="Order Confirmation" class="modal-info" size="lg" :ok-disabled="disabled" v-model="confirmScreen" @ok="executeOrder()" ok-title="Execute Order">

      <div v-if="lock_items_buy.length" class="row">
        <div class="col-12 text-center">
          <strong style="color: red">Prices locked for {{timerValue}} seconds...</strong>
        </div>
      </div>

      <div v-if="lock_items_buy.length" class="row">
        <div class="col-12">
          <h3>Sales Order</h3>
          <table class="table table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th>Item</th>
                <th>Quantity</th>
                <th class="text-right">Price</th>
                <th class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in lock_items_buy" >
                <td>{{item.sales_desc}}</td>
                <td>{{item.quantity}}</td>
                <td class="text-right">{{item.price_ask | currency}}</td>
                <td class="text-right">{{item.total | currency}}</td>
              </tr>
              <tr>
                <th class="text-right">
                  <select v-model="siteSo" class="form-control">
                    <option v-for="site in sites" v-bind:value="site.list_id">{{site.name}}</option>
                  </select>
                </th>
                <th colspan="2" class="text-right">Purchase Total:</th>
                <td class="text-right">{{total_lock_buy | currency}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="lock_items_sell.length" class="row">
        <div class="col-12">
          <h3>Purchase Order</h3>
          <table class="table table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th>Item</th>
                <th>Quantity</th>
                <th class="text-right">Price</th>
                <th class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in lock_items_sell" >
                <td>{{item.sales_desc}}</td>
                <td>{{item.quantity}}</td>
                <td class="text-right">{{item.price_bid | currency}}</td>
                <td class="text-right">{{item.total | currency}}</td>
              </tr>
              <tr>
                <th class="text-right">
                  <select v-model="sitePo" class="form-control">
                    <option v-for="site in sites" v-bind:value="site.list_id">{{site.name}}</option>
                  </select>
                </th>
                <th colspan="2" class="text-right">Sales Total:</th>
                <td class="text-right">{{total_lock_sell | currency}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </b-modal>
    <b-modal title="Order Complete" class="modal-success" ok-only size="sm" v-model="successScreen" ok-title="Close">
      <div class="row">
        <div class="col-12 text-center">
          <h4>Thank you!</h4>
        </div>
      </div>
    </b-modal>
    <b-modal title="Order Incomplete" class="modal-warning" ok-only size="lg" v-model="errorScreen" ok-title="Close">
      <div class="row">
        <div class="col-12 text-center">
          <h6>{{errorMessage}}</h6>
        </div>
      </div>
    </b-modal>
  </aside>
</template>

<script>
  import { pricing } from './mixins/pricing'

  export default {
    name: 'aside',
    mixins: [pricing],
    data () {
      return {
        lock_items_buy: [],
        lock_items_sell: [],
        items_buy: [],
        items_sell: [],
        spot_prices: null,
        confirmScreen: false,
        successScreen: false,
        errorScreen: false,
        errorMessage: '',
        timerValue: 60,
        disabled: false,
        sites: [],
        sitePo: '',
        siteSo: '',
        sellingLimitExceed: [],
        buyingLimitExceed: []
      }
    },
    watch: {
      timerValue: function (newVal, oldVal) {
        if (newVal === 0) {
          this.priceLockedItems()
          this.timerValue = 60
        }
      },
      items_buy: function (newVal, oldVal) {
        console.log('newVal, oldVal', newVal, oldVal)
        this.priceItems()
      },
      items_sell: function (newVal, oldVal) {
        this.priceItems()
      },
      spot_prices: function (newVal, oldVal) {
        this.priceItems()
      }
    },
    computed: {
      total_lock_buy: function () {
        var total = 0.0
        for (var i = 0; i < this.lock_items_buy.length; i++) {
          total += this.lock_items_buy[i].total
        }
        return total
      },
      total_lock_sell: function () {
        var total = 0.0
        for (var i = 0; i < this.lock_items_sell.length; i++) {
          total += this.lock_items_sell[i].total
        }
        return total
      },
      total_buy: function () {
        var total = 0.0
        for (var i = 0; i < this.items_buy.length; i++) {
          total += this.items_buy[i].total
        }
        return total
      },
      total_sell: function () {
        var total = 0.0
        for (var i = 0; i < this.items_sell.length; i++) {
          total += this.items_sell[i].total
        }
        return total
      }
    },
    methods: {
      removeAllClose () {
        this.items_buy = []
        this.items_sell = []
        this.lock_items_buy = []
        this.lock_items_sell = []
        document.body.classList.add('aside-menu-hidden')
      },
      removeBuyItem (index) {
        if (this.buyingLimitExceed.includes(this.items_buy[index].list_id)) {
          this.buyingLimitExceed.pop(this.items_buy[index].list_id)
        }
        this.items_buy.splice(index, 1)
      },
      removeSellItem (index) {
        if (this.sellingLimitExceed.includes(this.items_sell[index].list_id)) {
          this.sellingLimitExceed.pop(this.items_sell[index].list_id)
        }
        this.items_sell.splice(index, 1)
      },
      executeOrder () {
        const orderPayload = {
          purchase_orders: this.lock_items_sell,
          sales_orders: this.lock_items_buy,
          site_po: this.lock_items_sell.length ? this.sitePo : '',
          site_so: this.lock_items_buy.length ? this.siteSo : '',
          user: this.$auth.user()
        }

        this.$http.post('order/execute', {order: JSON.stringify(orderPayload)}).then(response => {
          this.items_buy = []
          this.items_sell = []
          this.lock_items_buy = []
          this.lock_items_sell = []
          document.body.classList.add('aside-menu-hidden')
          this.$bus.$emit('order-executed')
          let responseBody = response.body.status
          if (responseBody === 'limit boundary error') {
            this.errorScreen = true
            this.errorMessage = response.body.message
          } else {
            this.successScreen = true
          }
        }, response => {
          console.log(response)
        })
      },
      lockAndConfirm () {
        if (this.sellingLimitExceed.length < 1 || this.buyingLimitExceed.length < 1) {
          this.priceLockedItems()
          this.timerValue = 60
          this.confirmScreen = true
        }
      },
      priceLockedItems () {
        this.lock_items_buy = []
        for (var i = 0; i < this.items_buy.length; i++) {
          // console.log('priceLockedItems -> this.items_buy', this.items_buy)
          this.lock_items_buy.push({
            list_id: this.items_buy[i].list_id,
            sales_desc: this.items_buy[i].sales_desc,
            quantity: (this.items_buy[i].quantity > 0) ? this.items_buy[i].quantity : 1,
            price: this.items_buy[i].price_ask,
            total: ((this.items_buy[i].quantity > 0) ? this.items_buy[i].quantity : 1) * this.items_buy[i].price_ask,
            limit_quantity: this.items_buy[i].limit_quantity,
            is_unlimited: this.items_buy[i].is_unlimited
          })
        }

        this.lock_items_sell = []
        for (var j = 0; j < this.items_sell.length; j++) {
          console.log('priceLockedItems -> this.items_sell', this.items_sell)
          this.lock_items_sell.push({
            list_id: this.items_sell[j].list_id,
            sales_desc: this.items_sell[j].sales_desc,
            quantity: (this.items_sell[j].quantity > 0) ? this.items_sell[j].quantity : 1,
            price: this.items_sell[j].price_bid,
            total: ((this.items_sell[j].quantity > 0) ? this.items_sell[j].quantity : 1) * this.items_sell[j].price_bid,
            limit_quantity: this.items_sell[j].limit_quantity,
            is_unlimited: this.items_sell[j].is_unlimited
          })
        }
      },
      priceItems () {
        // BUY
        for (var j = 0; j < this.items_buy.length; j++) {
          const buyCurrentPrice = this.priceItem(this.spot_prices, this.items_buy[j])
          this.items_buy[j].price_bid = buyCurrentPrice.bid.toFixed(2)
          this.items_buy[j].price_ask = buyCurrentPrice.ask.toFixed(2)
          this.items_buy[j].total = this.items_buy[j].quantity * this.items_buy[j].price_ask
          if (parseInt(this.items_buy[j].quantity) > parseInt(this.items_buy[j].limit_quantity)) {
            if (this.buyingLimitExceed.includes(this.items_buy[j].list_id) || this.items_buy[j].is_unlimited) {
            } else {
              this.buyingLimitExceed.push(this.items_buy[j].list_id)
            }
          } else {
            if (this.buyingLimitExceed.includes(this.items_buy[j].list_id)) {
              this.buyingLimitExceed.pop(this.items_buy[j].list_id)
            }
          }
        }

        // SELL
        for (var i = 0; i < this.items_sell.length; i++) {
          const sellCurrentPrice = this.priceItem(this.spot_prices, this.items_sell[i])
          this.items_sell[i].price_bid = sellCurrentPrice.bid.toFixed(2)
          this.items_sell[i].price_ask = sellCurrentPrice.ask.toFixed(2)
          this.items_sell[i].total = this.items_sell[i].quantity * this.items_sell[i].price_bid
          if (parseInt(this.items_sell[i].quantity) > parseInt(this.items_sell[i].limit_quantity)) {
            if (this.sellingLimitExceed.includes(this.items_sell[i].list_id) || this.items_sell[i].is_unlimited) {
            } else {
              this.sellingLimitExceed.push(this.items_sell[i].list_id)
            }
          } else {
            if (this.sellingLimitExceed.includes(this.items_sell[i].list_id)) {
              this.sellingLimitExceed.pop(this.items_sell[i].list_id)
            }
          }
          // console.log('priceItems -> this.items_sell[i].quantity', this.items_sell[i].quantity)
          // console.log('priceItems -> this.items_sell[j]', this.items_sell[j].is_unlimited)
        }
      },
      addItemSell (itemData) {
        // console.log('addItemSell -> itemData', itemData)
        // console.log('addItemSell -> itemData', itemData.is_unlimited)
        var newItem = true

        for (var i = 0; i < this.items_sell.length; i++) {
          if (this.items_sell[i].list_id === itemData.list_id) {
            newItem = false
          }
        }

        if (newItem) {
          this.items_sell.unshift({
            list_id: itemData.list_id,
            sales_desc: itemData.sales_desc,
            price_bid: itemData.price_bid.toFixed(2),
            WC_OZWT: itemData.WC_OZWT,
            premium_bid: itemData.premium_bid,
            premium_ask: itemData.premium_ask,
            pricing_type: itemData.pricing_type,
            use_percent: itemData.use_percent,
            melt_plus: itemData.melt_plus,
            rounding: itemData.rounding,
            quantity: 1,
            total: itemData.price_bid.toFixed(2),
            limit_quantity: itemData.lc_quantity,
            is_unlimited: itemData.is_unlimited,
            premium_bid_percentage: (itemData.premium_bid + '').split('.')[1],
            premium_ask_percentage: (itemData.premium_ask + '').split('.')[1]
          })
        }
      },
      addItemBuy (itemData) {
        var newItem = true

        for (var i = 0; i < this.items_buy.length; i++) {
          if (this.items_buy[i].list_id === itemData.list_id) {
            newItem = false
          }
        }

        if (newItem) {
          this.items_buy.unshift({
            list_id: itemData.list_id,
            sales_desc: itemData.sales_desc,
            price_ask: itemData.price_ask.toFixed(2),
            WC_OZWT: itemData.WC_OZWT,
            premium_bid: itemData.premium_bid,
            premium_ask: itemData.premium_ask,
            pricing_type: itemData.pricing_type,
            use_percent: itemData.use_percent,
            melt_plus: itemData.melt_plus,
            rounding: itemData.rounding,
            quantity: 1,
            total: itemData.price_ask.toFixed(2),
            limit_quantity: itemData.lc_quantity,
            is_unlimited: itemData.is_unlimited,
            premium_bid_percentage: (itemData.premium_bid + '').split('.')[1],
            premium_ask_percentage: (itemData.premium_ask + '').split('.')[1]
          })
        }
      },
      getSites () {
        this.$http.get('order/sites').then(response => {
          this.sites = response.body
          this.disabled = this.sites.length ? this.disabled : !this.disabled
          this.sitePo = this.sites.length ? this.sites[0].list_id : ''
          this.siteSo = this.sites.length ? this.sites[0].list_id : ''
        }, response => {
          console.log(response)
        })
      }
    },
    beforeMount () {
      // console.log('MMM')
      this.$bus.$emit('request-spot-price')
      this.getSites()
    },
    mounted () {
      // console.log('PPPPP')
      this.quoteInterval = window.setInterval(() => {
        this.timerValue--
      }, 1000)
    },
    created () {
      this.$bus.$on('buy-item', ($event) => {
        this.addItemBuy($event)
      })
      this.$bus.$on('sell-item', ($event) => {
        this.addItemSell($event)
      })
      this.$bus.$on('spot-price', ($event) => {
        if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
          this.spot_prices = $event
        }
      })
    }
  }
</script>

<style>
  .modal-title {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// Aside.vue?bfe26744